/* eslint-disable no-shadow */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import { minorService } from '@/services';

export const state = {
  all: {},
  detail: {},
  absencesList: {},
};

export const getters = {
  absencesList(state) {
    return state.absencesList.data;
  },
};

export const actions = {
  init({ state }) {
    state.all = {};
    state.detail = {};
  },
  getAbsences({ commit, dispatch }, { minor_id, classroom_id }) {
    dispatch('setClassroom', classroom_id, { root: true });
    return minorService
      .getAbsences(minor_id, classroom_id)
      .then((response) => {
        commit('ABSENCES_LIST', response.data);
        return true;
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
  setScheduledAbsence({ commit, dispatch }, { minor_id, classroom, data }) {
    dispatch('setClassroom', classroom, { root: true });
    return minorService
      .setScheduledAbsence(minor_id, classroom, data)
      .then((response) => {
        commit('updateAbsenceSuccess', response);
        return response;
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
  removeAbsence({ commit, dispatch }, { id }) {
    return minorService
      .removeAbsence(id)
      .then(response => response)
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
  async qrScan({ commit, dispatch }, { minor_id, institute_id }) {
    return minorService
      .qrScan(minor_id, institute_id)
      .then(response => response)
      .catch(() => {
        throw new Error('something_went_wrong');
      });
  },
};

export const mutations = {
  updateAbsenceSuccess(state, users) {
    state.absence = {
      items: users,
    };
  },
  ABSENCES_LIST(state, data) {
    state.absencesList = data;
  },
};
